import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="font-display text-lg font-bold mb-2">EXUSIAI</div>
          <p className="text-sm text-muted max-w-xs">{t('footer.tagline')}</p>
        </div>
        <div className="flex gap-16">
          <div className="flex flex-col gap-2">
            <span className="text-xs text-muted uppercase tracking-wide mb-1">{t('footer.product')}</span>
            <Link to="/pricing" className="text-sm text-foreground/80 hover:text-foreground">{t('nav.pricing')}</Link>
            <Link to="/faq" className="text-sm text-foreground/80 hover:text-foreground">{t('nav.faq')}</Link>
            <Link to="/dashboard" className="text-sm text-foreground/80 hover:text-foreground">{t('nav.dashboard')}</Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs text-muted uppercase tracking-wide mb-1">{t('footer.legal')}</span>
            <Link to="/tos" className="text-sm text-foreground/80 hover:text-foreground">{t('footer.terms')}</Link>
            <Link to="/privacy" className="text-sm text-foreground/80 hover:text-foreground">{t('footer.privacy')}</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-6 py-4 text-xs text-muted">
          © {new Date().getFullYear()} Exusiai. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
}
